module.exports = __webpack_public_path__ + "img/scene-3.b5cd90c0.png";